// extracted by mini-css-extract-plugin
module.exports = {"container":"SlideCarouselLogo-module--container--1QlvI","logo":"SlideCarouselLogo-module--logo--14_rd","hidden":"SlideCarouselLogo-module--hidden--2g3lW"};